<template>
  <div id="tertiary-insurance">
    <div class="tertiary-insurance-view">
      <div class="step-inner-navbar"></div>

      <div class="step-inner-content">
        <div class="vue-form">
          <el-form v-model="tertiaryInsuranceForm">
            <el-row :gutter="15">
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Relationship
                      <span class="star">*</span>
                    </label>
                    <el-select
                      v-model="tertiaryInsuranceForm.relationship"
                      placeholder="Select Relationship"
                      @change="fillPrimaryDetails()"
                      filterable
                      clearable
                      @clear="clearNameSerach"
                      default-first-option
                      :reserve-keyword="false"
                      
                    >
                      <el-option
                        v-for="(type, index) in relationships"
                        :key="index"
                        :value="type"
                        :label="type"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.relationship"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Plan Type
                    </label>
                    <el-select
                      placeholder="Select Plan Type"
                      v-model="tertiaryInsuranceForm.plan_type"
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      
                    >
                      <el-option
                        v-for="(type, index) of planTypes"
                        :key="index"
                        :value="type"
                        :label="type"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.plan_type"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      First Name
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="tertiaryInsuranceForm.first_name"
                      placeholder="Enter First Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.first_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Middle Name </label>
                    <el-input
                      v-model="tertiaryInsuranceForm.middle_name"
                      placeholder="Enter Middle Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.middle_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Last Name
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="tertiaryInsuranceForm.last_name"
                      placeholder="Enter Last Name"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.last_name"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input gender-group">
                  <el-form-item>
                    <label for="text"> Gender <span class="star">*</span></label>
                    <el-select
                      v-model="tertiaryInsuranceForm.gender"
                      placeholder="Select Gender"
                      filterable
                      default-first-option
                      :reserve-keyword="false"                      
                      clearable
                    >
                      <el-option
                        v-for="(gender, index) in genderOptions"
                        :key="index"
                        :label="gender"
                        :value="gender"
                      ></el-option>
                    </el-select>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.gender"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="date-of-birth case-creation__input">
                  <dobVersion
                    v-if="showPatientDob"
                    :dobData="tertiaryInsuranceForm"
                    :validataionErrors="getErrors"
                    :errorKey="'billing_info.insurance.tertiary_insurance.date_of_birth'"
                  >
                  </dobVersion>
                </div>
              </el-col>

              <el-col :xl="4" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <payor
                      :payorData="tertiaryInsuranceForm"
                      v-if="show"
                      :clearPayor="clearPayorData"
                      @payorSelect="fillInsurance"
                      insuranceType="tertiary_insurance"
                      :billToInsurance="billTo"
                    >
                    </payor>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.payor"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Insurance Carrier Code <span class="star">*</span> </label>
                    <el-input
                      v-model="tertiaryInsuranceForm.insurance_carrier_code"
                      placeholder="Enter Insurance Carrier Code"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.insurance_carrier_code"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">
                      Policy No
                      <span class="star">*</span>
                    </label>
                    <el-input
                      v-model="tertiaryInsuranceForm.policy_id"
                      placeholder="Enter Policy No"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.policy_id"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text">Group #</label>
                    <el-input
                      v-model="tertiaryInsuranceForm.group"
                      placeholder="Enter Group #"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.group"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Address Line 1 <span class="star">*</span></label>
                    <el-input
                      v-model="tertiaryInsuranceForm.address_line_1"
                      placeholder="Enter Address Line 1"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.address_line_1"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Address Line 2 </label>
                    <el-input
                      v-model="tertiaryInsuranceForm.address_line_2"
                      placeholder="Enter Address Line 2"
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.address_line_2"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <label for="text"> Zip <span class="star">*</span></label>
                    <el-input
                      v-model="tertiaryInsuranceForm.zip"
                      placeholder="Enter Zip"
                      maxlength="5"
                      @input="getStateCity"
                      
                    ></el-input>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.zip"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <state
                      :stateData="tertiaryInsuranceForm"
                    ></state>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.state"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="6" :sm="8" :xs="12">
                <div class="case-creation__input">
                  <el-form-item>
                    <city
                      :cityData="tertiaryInsuranceForm"
                      v-if="show"
                    ></city>
                    <p class="err">
                      <FormError
                        errorName="billing_info.insurance.tertiary_insurance.city"
                      ></FormError>
                    </p>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
const payor = defineAsyncComponent(() => import("@/components/misc/Payor"));
const dobVersion = defineAsyncComponent(() =>
  import("@/components/misc/DobNewFormat")
);
const state = defineAsyncComponent(() =>
  import("@/components/misc/BillingState")
);
const city = defineAsyncComponent(() =>
  import("@/components/misc/BillingCity")
);
import AppHelper from "@/mixins/AppHelper";
import InsuranceHelper from "@/mixins/InsuranceHelper";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tertiaryInsuranceForm: JSON.parse(
        JSON.stringify(caseConstants.insurance)
      ),
      relationships: caseConstants.BILLING_RELATIONSHIPS,
      planTypes: ["INDIVIDUAL", "FAMILY"],
      genderOptions: ["MALE", "FEMALE"],
      payorData: {},
      show: false,
      showPatientDob: false,
      clearPayorData: false,
      patientData: {},
      facilityState: "",
      stateCarrierMapping: caseConstants.stateCarrierMapping,
      stateMedicaidCarrierMapping: caseConstants.stateMedicaidCarrierMapping,
      stateAetnaMapping: caseConstants.stateAetnaMapping,
    };
  },
  components: {
    FormError,
    payor,
    dobVersion,
    state,
    city,
  },
  mixins: [AppHelper, InsuranceHelper],
  computed: {
    ...mapGetters("help", ["getAllStates"]),
    ...mapGetters("cases", ["getCaseInformation", "getStateAndCity"]),
     ...mapGetters("errors", ["getErrors"]),
  },
  props: ["parentRefs", "tertiaryInsurance", "refreshDob", "state", "billTo"],
  mounted() {
    this.show = true;
    this.showPatientDob = true;
    if (this.tertiaryInsurance) {
      this.tertiaryInsuranceForm = { ...this.tertiaryInsurance };
    }
    if (this.$route.params.case_id) {
      this.checkCaseInfo();
      this.patientData = this.getCaseInformation.patient_info;
    }
  },
  methods: {
    async getStateCity() {
      try {
        let params = {
          zip: this.tertiaryInsuranceForm.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.tertiaryInsuranceForm.state = this.getStateAndCity.state;
          this.tertiaryInsuranceForm.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchStates() {
      await this.$store.dispatch("help/fetchAllStates");
    },
    getTertiaryInsuranceFormData() {
      return this.getFormattedValues(this.tertiaryInsuranceForm);
    },
    checkCaseInfo() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.billing_info &&
        this.getCaseInformation.billing_info.insurance &&
        this.getCaseInformation.billing_info.insurance.tertiary_insurance
      ) {
        this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
          this.getCaseInformation.billing_info.insurance.tertiary_insurance
        );
        this.payorData =
          this.getCaseInformation.billing_info.insurance.tertiary_insurance
            .payor || {};
      }
    },
    clearNameSerach() {
      this.tertiaryInsuranceForm = {
        relationship: "",
        plan_type: "",
        payer: "",
        payor: "",
        insurance_code: "",
        gender: "",
        date_of_birth: "",
        policy_plan: "",
        group_or_plan: "",
        group: "",
        patient_policy: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        zip: "",
        first_name: "",
        middle_name: "",
        last_name: "",
      };
      this.clearPayorData = true;
      setTimeout(() => {
        this.show = true;
      }, 100);
    },
    fillInsurance(data) {
      const insuranceName = data?.insurance_name || data?.name;
       if (insuranceName == "Medicaid") {
        this.tertiaryInsuranceForm.payor = insuranceName;
        this.tertiaryInsuranceForm.insurance_carrier_code =
          this.stateMedicaidCarrierMapping[this.facilityState] || "";
      } else if (insuranceName == "Aetna") {
        this.tertiaryInsuranceForm.payor = insuranceName;
        this.tertiaryInsuranceForm.insurance_carrier_code =
          this.stateAetnaMapping[this.facilityState] || "";
      } else if (data) {
        this.tertiaryInsuranceForm.payor = insuranceName;
        if (data.payor_electronic_id) {
          this.tertiaryInsuranceForm.insurance_carrier_code =
            data.payor_electronic_id;
        } else {
          this.tertiaryInsuranceForm.insurance_carrier_code = "";
        }
      }
    },
    fillPrimaryDetails() {
      this.clearPayorData = false;
      if (this.tertiaryInsuranceForm.relationship === "Self") {
        this.showPatientDob = false;
        let patientInformation =
          this.parentRefs && this.parentRefs.patientInformationForm
            ? this.parentRefs.patientInformationForm.formatPatientInfo()
            : this.patientData;
        this.tertiaryInsuranceForm.first_name = patientInformation.first_name;
        this.tertiaryInsuranceForm.middle_name = patientInformation.middle_name;
        this.tertiaryInsuranceForm.last_name = patientInformation.last_name;
        this.tertiaryInsuranceForm.gender = patientInformation.gender;

        this.tertiaryInsuranceForm.date_of_birth =
          patientInformation.date_of_birth;

        this.tertiaryInsuranceForm.city = patientInformation.city;
        this.tertiaryInsuranceForm.state = patientInformation.state;
        this.tertiaryInsuranceForm.zip = patientInformation.zip;
        this.tertiaryInsuranceForm.address_line_1 =
          patientInformation.address_line_1;
        this.tertiaryInsuranceForm.address_line_2 =
          patientInformation.address_line_2;
        setTimeout(() => {
          this.showPatientDob = true;
        }, 100);
      }
    },
  },
  watch: {
    tertiaryInsurance: {
      deep: true,
      handler: function (newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.tertiaryInsuranceForm = { ...newVal };
        }
      },
    },
    refreshDob: {
      immediate: true,
      deep: true,
      handler: function () {
        this.showPatientDob = this.refreshDob;
      },
    },
    state: {
      immediate: true,
      deep: true,
      handler: function () {
        this.facilityState = this.state;
      },
    },
  },
};
</script>
